import React from "react";
import DownloadArrow from "../img/DownloadArrow.svg";

const InvoiceTemplate = ({ invoice, generatePdf }) => {
  console.log(invoice);
  return (
    <div className=" w-full">
      {/* Header */}
      <div className="bg-[#4C3A68] text-white py-3 px-4 text-xl font-semibold">
        Tax Invoices
      </div>

      {/* Top Section */}
      <div className="py-5 px-0 sm:px-4">
        <div className="flex justify-between">
          <div className="flex flex-col">
            <span className="text-[10px] font-light">
              ORIGINAL FOR RECIPIENT
            </span>
            <span className="font-semibold text-2xl">Tax Invoices</span>
          </div>
          <div
            className="flex items-center gap-1 cursor-pointer"
            onClick={generatePdf} // visible normally
            data-ignore-pdf="true"
          >
            <span className="text-[#9367D7] text-xs">Download</span>
            <img src={DownloadArrow} alt="" className="h-[10px]" />
          </div>
        </div>
        <div className="flex sm:flex-row justify-between gap-4 mt-10">
          <div className="w-1/3">
            <p className="text-base text-[#777777]">Invoice to</p>
            <p className="text-lg font-medium">{invoice.company_name}</p>
            <p className="text-sm font-normal">
              {" "}
              {invoice.address?.address_1}, {invoice.address?.district},{" "}
              {invoice.address?.state} - {invoice.address?.pincode}
            </p>
            {invoice.address?.license_number &&
              invoice.address.license_number.length > 2 && (
                <p className="text-base font-medium">
                  GSTIN - {invoice.address.license_number}
                </p>
              )}
          </div>
          <div className="w-1/3">
            <p className="text-base text-[#777777]">Invoice from</p>
            <p className="text-lg font-medium">GKS INFOTECH PRIVATE LIMITED</p>
            <p className="text-sm font-normal">
              {" "}
              29/1173 D , Second Floor , Infinity One Sahodharan Ayyappan Road ,
              Vyttila , Ernakulam Vyttila 32 - Kerala IN 682019
            </p>
            <p className="text-base font-medium">GSTIN - 32AAHCG3791L1ZB</p>
          </div>
          {/* <div>
            <p className="text-base text-[#777777]">Invoice No :</p>
            <p className="text-lg font-medium">{invoice.invoice_code}</p>
          </div> */}
          <div className="w-1/3 sm:flex sm:justify-end">
            <span className="text-base font-normal">
              Date:{" "}
              {new Date(invoice.invoiced_date).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-between py-5 px-0 sm:px-4">
        <div class="flex flex-col">
          <span className="text-base text-[#777777] ">Invoice Number</span>
          <span className="text-lg">{invoice.invoice_code}</span>
        </div>
        {/* <div class="flex flex-col">
          <span className="text-base text-[#777777] ">Billing cycle</span>
          <span className="text-lg">Monthly</span>
        </div> */}
        {invoice?.payment_method && (
          <div class="flex flex-col">
            <span className="text-base text-[#777777] ">Payment mode</span>

            <span className="text-lg">{invoice.payment_method}</span>
          </div>
        )}
        <div class="flex flex-col">
          <span className="text-base text-[#777777] ">Number</span>
          <span className="text-lg">Number</span>
        </div>
      </div>

      {/* Table */}
      <div className="w-full overflow-x-auto">
        <table className="w-full mt-6 text-left border-t  border-[#CDC5FF]">
          <thead className="text-[#777777] text-base  border-b border-[#CDC5FF]">
            <tr>
              <th className="px-4 py-2">Service</th>
              <th className="px-4 py-2">Quantity</th>
              <th className="px-4 py-2">Price</th>
              <th className="px-4 py-2">Discount</th>
              <th className="px-4 py-2">Total</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="w-full bg-[white] h-[5px]" colSpan={5}></td>
            </tr>
            <tr>
              <td
                className="w-full  px-4 bg-[#F1EFFF] text-base font-medium py-2 rounded"
                colSpan={5}
              >
                {invoice.line_data.map((item) => item.item_name).join(" + ")}
              </td>
            </tr>

            {invoice.line_data.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td className="w-full bg-[white] h-[10px]" colSpan={5}></td>
                </tr>

                <tr>
                  <td
                    className="w-full bg-[#FAF9FF] px-4 text-xs text-[#777777]"
                    colSpan={5}
                  >
                    Service name
                  </td>
                </tr>
                {/* Main license row */}
                <tr className="">
                  <td className="px-4 py-2 font-medium">{item.item_name}</td>
                  <td className="px-4 py-2 font-medium">Quantity</td>
                  <td className="px-4 py-2">{item.price}</td>
                  <td className="px-4 py-2">{item.offer_amount}</td>
                  <td className="px-4 py-2">{item.item_amount}</td>
                </tr>

                {/* If top_up exists and is an array with items */}
                {Array.isArray(item.top_up) &&
                  item.top_up.length > 0 &&
                  item.top_up.map((topup, idx) => (
                    <tr
                      key={`topup-${index}-${idx}`}
                      className="border-b border-[#EEE8FF] bg-[#FAF9FF]"
                    >
                      <td className="px-4 py-2 text-sm text-[#4C3A68]">
                        {topup.item_name}
                      </td>
                      <td className="px-4 py-2 text-sm">{topup.price}</td>
                      <td className="px-4 py-2 text-sm">
                        {topup.offer_amount}
                      </td>
                      <td className="px-4 py-2 text-sm">{topup.item_amount}</td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
            <tr>
              <td colSpan={3}></td>
              <td className="px-4 py-2 text-[#777777] border-b border-[#CDC5FF]">
                Subtotal
              </td>
              <td className="px-4 py-2 font-medium border-b border-[#CDC5FF]">
                INR {invoice.sub_total}
              </td>
            </tr>
            {/* <tr>
              <td colSpan={2}></td>
              <td className="px-4 py-2 text-[#777777]">
                IGST @ {invoice.tax_percentage}%
              </td>
              <td className="px-4 py-2 font-medium">
                INR {invoice.tax_amount}
              </td>
            </tr> */}

            {invoice.tax_configurations.map((tax, index) => (
              <tr key={index}>
                <td colSpan={3}></td>
                <td
                  className={`px-4 py-2 text-[#777777] ${
                    index === invoice.tax_configurations.length - 1
                      ? "border-b border-[#CDC5FF]"
                      : ""
                  }`}
                >
                  {tax.tax_name} {tax.percentage}%
                </td>
                <td
                  className={`px-4 py-2 font-medium ${
                    index === invoice.tax_configurations.length - 1
                      ? "border-b border-[#CDC5FF]"
                      : ""
                  }`}
                >
                  INR {tax.value}
                </td>
              </tr>
            ))}

            {/* <tr>
              <td colSpan={3}></td>
              <td className="px-4 py-2 text-[#777777] border-b border-[#CDC5FF]">
                TDS @ {invoice.tds_percentage}%
              </td>
              <td className="px-4 py-2 font-medium border-b border-[#CDC5FF]">
                INR -{invoice.tds_amount}
              </td>
            </tr> */}
            <tr>
              <td colSpan={3}></td>
              <td className="px-4 py-2 text-[#777777]">Invoice total</td>
              <td className="px-4 py-2 text-lg font-medium">
                INR {invoice.grand_total_amount}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="w-full h-[1px] bg-[#878787] mt-5 mb-10"></div>

        <div className="flex flex-col py-5 px-0 sm:px-4">
          <span className="text-base">
            Click here to login to the billing portal and make payment.
          </span>
          <span className="text-base font-medium">Billing terms</span>
          <span>
            1 The price offered is subject to the minimum quantity billed in the
            invoice above.
          </span>
          <span>
            2 Our services are governed by the Terms of Service (TOS) found at{" "}
            <span className="text-[#4B69FF] cursor-pointer">
              terms & conditions
            </span>
            , unless Customer has executed a separate master sales Agreement
          </span>
        </div>

        <div className="w-full h-[1px] bg-[#878787] mt-5 mb-10"></div>

        <div class="flex flex-col">
          <h1 className="text-lg font-medium mb-5">
            GKS INFOTECH PRIVATE LIMITED
          </h1>
          <div className="flex text-base justify-between text-[#777777]">
            <span className="w-3/12">CIN</span>
            <span className="w-3/12">GSTIN</span>
            <span className="w-3/12">PAN number</span>
            <span className="w-3/12">SAC</span>
          </div>
          <div className="flex text-lg justify-between ">
            <span className="w-3/12">U72900KL2018PTC053857</span>
            <span className="w-3/12">32AAHCG3791L1ZB</span>
            <span className="w-3/12">AAHCG3791L</span>
            <span className="w-3/12">997331</span>
          </div>
        </div>
        <div className="w-full h-[1px] my-1"></div>
      </div>
    </div>
  );
};

export default InvoiceTemplate;
